import { render, staticRenderFns } from "./indexTab.vue?vue&type=template&id=715ce2a8&scoped=true&"
import script from "./indexTab.vue?vue&type=script&lang=js&"
export * from "./indexTab.vue?vue&type=script&lang=js&"
import style0 from "./indexTab.vue?vue&type=style&index=0&id=715ce2a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715ce2a8",
  null
  
)

export default component.exports